/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Compliance_Llm_UpdatedInputs */



/**
* | output |
* | --- |
* | "Compliance LLM settings were updated" |
*
* @param {Audit_Details_Compliance_Llm_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_compliance_llm_updated = /** @type {((inputs?: Audit_Details_Compliance_Llm_UpdatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Compliance_Llm_UpdatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance-LLM-Einstellungen wurden aktualisiert")
	return /** @type {LocalizedString} */ ("Compliance LLM settings were updated")
});